// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3I3dQ","filesListContainer":"PosDisputesFiles_filesListContainer__1kUNR","filesButton":"PosDisputesFiles_filesButton__eBGHo"};